<template>
    <div>
        <!-- Переможці -->
        <div class="mb-2 green-text fw-bold fst-italic">Переможці</div>
        
        <div v-if="winners.length">
            <div v-for="w in winners" :key="'win_'+w.id" class="panel-tag mb-2">
                <div class="fw-semibold">
                    {{ w.win.company }}
                    <template v-if="w.win.contact_name || w.win.contact_tel">
                        ({{ w.win.contact_name || 'контакт' }} тел:{{ w.win.contact_tel || '-' }})
                    </template>
                </div>
                
                <!-- рядки по валютам -->
                <div v-if="w.hrn_summ > 0">
                    {{ fm(w.hrn_summ) }} грн. без ПДВ
                    <template v-if="w.has_pdv">
                        ({{ fm(w.hrn_summ + w.hrn_summ_pdv) }} грн. з ПДВ)
                    </template>
                </div>
                
                <div v-if="w.usd_summ > 0">
                    {{ fm(w.usd_summ) }} USD без ПДВ
                    <template v-if="w.has_pdv">
                        ({{ fm(w.usd_summ + w.usd_summ_pdv) }} USD з ПДВ)
                    </template>
                </div>
                
                <div v-if="w.eur_summ > 0">
                    {{ fm(w.eur_summ) }} EUR без ПДВ
                    <template v-if="w.has_pdv">
                        ({{ fm(w.eur_summ + w.eur_summ_pdv) }} EUR з ПДВ)
                    </template>
                </div>
                
                <!-- ПДВ бейдж -->
                <span class="ms-1" :style="{ color: 'green' }">
          {{ w.vatLabel }} {{ Math.round(w.taxrate * 100) }}%
        </span>
                
                <!-- оцінка -->
                <div>
                    оцінка {{ fm(w.summ) }} грн.
                </div>
            </div>
        </div>
        <div v-else class="text-muted">Немає переможців</div>
        
        <!-- Інші заявки -->
        <div class="mt-3 redtext fw-bold fst-italic">Інші заявки</div>
        <div v-for="a in otherApps" :key="'other_'+a.id" class="border_bt mb-1" :class="'app_'+(a.status || 'unknown')">
            {{ a.id }} {{ a.company }}
            <template v-if="a.contact_name || a.contact_tel">
                ({{ a.contact_name || 'контакт' }} тел:{{ a.contact_tel || '-' }})
            </template>
            <!-- додаткова інфа, якщо треба -->
            <span v-html="getAppInfo(a)"></span>
        </div>
        
        <!-- Кнопки -->
        <div id="positions_control" class="mt-3" style="width:100%;">
            <div class="row">
                <div class="col-6">
                    <div
                        class="btn btn-outline-primary btn_auto_render mb-2 mt-2 waves-effect waves-themed"
                        @click="auto_distribute"
                    >
                        Розподілити
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'protocol_request',
    props: {
        protocol: {type: Object, required: true},
    },
    
    computed: {
        // массив метаданных по заявкам (applications_info из протокола)
        appsInfo() {
            return this.protocol?.applications_info || [];
        },
        
        // winners: собираем по position_grid_add (каждый grid = app{ID})
        winners() {
            const holders = this.protocol?.position_grid_add || [];
            const result = [];
            
            holders.forEach((g) => {
                const appId = String(g.id || '').replace(/^app/, '');
                const meta = this.appsInfo.find(a => String(a.id) === appId) || {};
                
                let summUAH = 0;  // сумма оценки в грн (Sum_{appId})
                let hrn = 0, usd = 0, eur = 0; // суммы «без ПДВ» по валютам
                
                (g.records_push || []).forEach(rec => {
                    // оценка (грн)
                    summUAH += this.num(rec['Sum_' + appId]);
                    
                    // валютные суммы: ValPrice_{id} * quantity_protocol{id} по currency_app_{id}
                    const q = this.num(rec['quantity_protocol' + appId]);
                    const valPrice = this.num(rec['ValPrice_' + appId]);
                    const c = String(rec['currency_app_' + appId] || '');
                    
                    if (c === '1') hrn += valPrice * q;
                    else if (c === '2') usd += valPrice * q;
                    else if (c === '3') eur += valPrice * q;
                });
                
                const taxrate = this.getAPPtaxrate(meta);
                const hasPDV = ['1', '2', '3'].includes(String(meta.has_pdv || '0'));
                
                result.push({
                    id: appId,
                    win: meta,
                    summ: summUAH,
                    hrn_summ: hrn,
                    usd_summ: usd,
                    eur_summ: eur,
                    hrn_summ_pdv: hrn * taxrate,
                    usd_summ_pdv: usd * taxrate,
                    eur_summ_pdv: eur * taxrate,
                    taxrate,
                    has_pdv: hasPDV,
                    vatLabel: hasPDV ? 'є ПДВ' : 'без ПДВ'
                });
            });
            
            // сортировка: по summ (грн) по убыванию, как в оригинале
            result.sort((a, b) => (a.summ < b.summ ? 1 : a.summ > b.summ ? -1 : 0));
            return result;
        },
        
        // остальные заявки (не попали в winners и не архив)
        otherApps() {
            const winnerIds = new Set(this.winners.map(w => String(w.id)));
            return (this.appsInfo || []).filter(a => !winnerIds.has(String(a.id)) && a.status !== 'archive');
        },
    },
    
    methods: {
        auto_distribute() {
            EventBus?.$emit?.('winners:auto_distribute');
        },
        
        // налоговая ставка по заявке (has_pdv: "0","1","2","3")
        getAPPtaxrate(app = {}) {
            switch (String(app.has_pdv ?? '0')) {
                case '1':
                    return 0.20;
                case '2':
                    return 0.14;
                case '3':
                    return 0.07;
                default:
                    return 0;
            }
        },
        
        // форматирование чисел (с пробелами, 2 знака)
        fm(n) {
            const x = Number(n || 0);
            // заменяем небьющиеся пробелы на обычные
            return x.toLocaleString('uk-UA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).replace(/\u00A0/g, ' ');
        },
        
        num(v) {
            const n = parseFloat(String(v ?? 0).replace(/\s/g, '').replace(',', '.'));
            return isNaN(n) ? 0 : n;
        },
        
        // произвольная строка статуса/описания заявки — если надо
        getAppInfo(app) {
            // верни что-то из meta: paymentinfo / deliveryinfo / summprop / positioninfo и т.д.
            // оставим кратко: курсы + позицій
            const pieces = [];
            if (app.eur_exchange_rate && app.eur_exchange_rate !== '0.000000') {
                pieces.push(`EUR ${this.num(app.eur_exchange_rate)}`);
            }
            if (app.usd_exchange_rate && app.usd_exchange_rate !== '0.000000') {
                pieces.push(`USD ${this.num(app.usd_exchange_rate)}`);
            }
            if (app.positioninfo) pieces.push(app.positioninfo);
            return pieces.length ? ` &nbsp;|&nbsp; ${pieces.join(' &nbsp;|&nbsp; ')}` : '';
        },
    },
}
</script>

<style scoped>
.green-text {
    color: #2e7d32;
}

.redtext {
    color: #c62828;
}

.border_bt {
    border: 1px solid #eee;
    padding: .5rem .75rem;
    border-radius: 2px;
}

.fw-semibold {
    font-weight: 600;
}
</style>
